const getArticlePayload = (article) => ({
  articleId: article.id,
  title: article.title,
  link: article.link,
})

export default (tracker) => ({
  async viewArticle(article) {
    await tracker.track('Support Article Viewed', getArticlePayload(article))
  },

  async rateArticle(article, rating) {
    await tracker.track('Support Article Rated', {
      ...getArticlePayload(article),
      rating,
    })
  },

  async search(query, resultsLength) {
    await tracker.track('Support Articles Searched', { query, resultsLength })
  },

  async viewCategory(category) {
    await tracker.track('Support Category Viewed', {
      categoryId: category.id,
      level: category.level,
      title: category.title,
      link: category.link,
    })
  },
})
